import _ from 'lodash';
import ApplicationRecord from './ApplicationRecord';
import Product from './Product';
import ImageRecord from './ImageRecord';
import Unit from './Unit';

export default class ProductCategory extends ApplicationRecord({
  ID: 1,
  Title: '',
  Content: '',
  LabelArtID: 'N° articles',
  LabelDesignation: 'Désignation',
  LabelUnit: 'tonne(s)',
  _embedded: {},
}) {
  /**
     * Give the fullName with lastname uppercased
     * Ex: Hadrien FROGER
     * @return {String}
     */
  fullname() {
    const firstName = _.trim(this.GivenName);
    const lastName = _.trim(this.LastName);
    return firstName + (_.isEmpty(lastName) ? '' : ' ' + lastName);
  }

  /**
   * @return {Product}
   */
  products() {
    return this._getMany('Products', i => new Product(i));
  }
  /**
   * @return {ImageRecord}
   */
  thumbnail() {
    return this._getOne('CategoryImg', ImageRecord);
  }

  /**
   * @return {Unit} Unit of the category
   */
  unit() {
    return this._getOne('Unit', Unit);
  }
}



// WEBPACK FOOTER //
// ./src/models/ProductCategory.js